import React from 'react'
import Head from "next/head";
import CocoCart from '@/components/casestudy/CocoCart';

const cocoCart = () => {
    return (
        <>
            <Head>
                <title>CocoCart Case Study for QueueBuster POS Solutions</title>
                <link rel="canonical" href="https://queuebuster.co/casestudy/coco-cart" />
                <link rel="alternate" href="https://queuebuster.co/casestudy/coco-cart" hrefLang="en-us" />
                <meta name="description" content="Discover how QueueBuster POS helped Coco Cart grow from a single store to 65 locations with seamless billing, inventory management, and CRM integration." />
                <meta property="og:title" content="How QueueBuster POS Transformed Coco Cart from 1 Store into a 65-Store Chain" />
                <meta property="og:description" content="Read the inspiring story of Coco Cart’s transformation from one store to 65 with QueueBuster POS. Learn how our features streamlined billing, inventory, and CRM for seamless expansion and operational efficiency." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/Group+1171276118+(1).png" />
                <meta property="og:url" content="https://queuebuster.co/casestudy/coco-cart" />
            </Head>
            <CocoCart />
        </>
    )
}

export default cocoCart
